var $974eae3eb0fd8ae2$exports = {};
$974eae3eb0fd8ae2$exports = {
    "help": `Pomo\u{107}`,
    "info": `Informacije`
};


export {$974eae3eb0fd8ae2$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
